import styled from 'styled-components';
import { TextField } from '@mui/material';

export const StyledTextField = styled(TextField)`
  div:has(> .textarea-copyable) {
    margin-right: 0 !important;
  }
`;
